export default __webpack_public_path__ + "static/media/img4.bfbca5e9.png";